const statuses = {
	1: 'Inativo', 
	2: 'Ativo', 
	3: 'Eventual'
};

export {
	statuses
}